import { translate } from '../../../base/i18n/functions';
import { IconWhiteboard, IconWhiteboardHide } from '../../../base/icons/svg';
import { connect } from '../../../base/redux/functions';
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { AbstractButton } from '../../../base/toolbox/components';
import { setOverflowMenuVisible } from '../../../toolbox/actions.web';
import { setWhiteboardOpen } from '../../actions';
import { isWhiteboardVisible } from '../../functions';
/**
 * Component that renders a toolbar button for the whiteboard.
 */
class WhiteboardButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.whiteboard';
        this.icon = IconWhiteboard;
        this.label = 'toolbar.showWhiteboard';
        this.toggledIcon = IconWhiteboardHide;
        this.toggledLabel = 'toolbar.hideWhiteboard';
        this.toggledTooltip = 'toolbar.hideWhiteboard';
        this.tooltip = 'toolbar.showWhiteboard';
    }
    /**
     * Handles clicking / pressing the button, and opens / closes the whiteboard view.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        // @ts-ignore
        const { dispatch, _toggled } = this.props;
        dispatch(setWhiteboardOpen(!_toggled));
        dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        // @ts-ignore
        return this.props._toggled;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
    return {
        _toggled: isWhiteboardVisible(state)
    };
}
// @ts-ignore
export default translate(connect(_mapStateToProps)(WhiteboardButton));
